<template>
  <!-- 逾期未取：未取出 -->
    <div class="overdue">
      <div class="search">
        <div class="dataTime">
            <!-- <van-field>
              <template #input>
                <van-checkbox v-model="manageGet"  checked-color="#3399ff">管理员已取出</van-checkbox>
              </template>
            </van-field> -->

            <div class="overSearch">
              <van-search
              v-model="searchValue"
              show-action
              placeholder="请输入查询的天数"
              @search="onSearch"
              @input="onSearch"
            >
              <template #action>
                <div @click="onSearch(searchValue)">搜索</div>
              </template>
            </van-search>
            <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin-right: 5%;">{{ queryDataLength }}</span>
            </div>

            <!-- <van-search
              v-model="searchValue"
              placeholder="请输入查询的天数"
              @input="onSearch"
              @search="onSearch"
            >
            </van-search>
            <van-search
              v-model="searchValue"
              placeholder="请输入查询的车牌号"
              @input="onSearch"
              @search="onSearch"
            >
            </van-search> -->
           
           
            <!-- <van-divider /> -->
          <van-divider style="margin: 0;" />
        </div>
      </div>
      <div class="searchContent">
        <van-list
          :finished="finished"
          finished-text="没有更多了"
        >
        <!-- :title="'身份证号：'+item.idNo" -->
        <!-- <van-cell v-for="item in responseDataArray" :key="item.id"  :title="'料盒编号：'+item.boxCode">
          <van-button  plain hairline type="info" @click="showDetail(item)">查看详情</van-button>
        </van-cell> -->
        <van-cell v-for="item in responseDataArray" :key="item.id" >
          <van-row>
            <van-col :span="16">
              <van-row>
                <van-col :span="8" style="text-align: right;">料盒编号：</van-col>
                <van-col :span="16">{{ item.boxCode }}</van-col>
              </van-row>
              <van-row>
                <van-col :span="8" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="16">{{ item.plateNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="5">
               <van-button  style="height: 42px;" plain hairline type="info" @click="showDetail(item)"
               >{{ '查看详情' }}</van-button>
            </van-col>
          </van-row>
        </van-cell>
        </van-list>
      </div>
  
      <!-- 450881200010058922 -->
      <!-- 查看详情信息 -->
          <van-overlay :show="showDataDetail" @click="showDataDetail=false">
            <div class="wrapper" @click.stop>
              <div class="overdueBlock">
                <div class="title">
                  <span>详情
                    <van-icon name="close" class="cancel" @click="cancelForm"/>
                  </span>
                </div>
                <van-cell title="车牌号码："  v-model="showList.plateNo"/>
                <van-cell title="存放位置：" v-model="showList.boxCode">
                </van-cell>
                <van-cell title="存入时间： " v-model="showList.handleTime" />
                <div style="margin: 16px;">
                  <van-button round block type="info" @click="showDataDetail = false">
                    确 定</van-button>
                </div>
              </div>
            </div>
          </van-overlay>
    </div>
  </template>
  
  <script>
  import {QueryStayBox,ModifyApplyInfo} from '@/my_js//HttpRequest.js'
  import {formatTime,getNowTime,formatDateTime} from '@/utils/date.js'
  import { Notify } from 'vant'
  import PlateNumber from '../plateNo.vue'
  export default {
    components:{
      PlateNumber
    },
    filters:{
    },
    mounted(){
      // this.onSearch()
  },
    data(){
      return{
        dataForm:{
          stayDays:null,//未领取天数
        },
        searchValue:'',//搜索内容
        loading:false,
        finished:false,
        responseDataArray:[],//响应数据
        showDataDetail:false,//详情显示
        showList:[],//详情信息列表
        manageGet:false,//管理员是否取出
        queryDataLength:null,//查询到的数据量
      }
    },
    methods:{
      // 返回
      goBack(){
        console.log('返回管理员首页');
        this.$router.push('/manager')
      },
      // 搜索
      onSearch(val){
        this.loading = true
        console.log('搜索输入内容：',val);
        const data = {
            stayDays:val
        }
       if(val == null || val == ''){
        this.responseDataArray = []
        this.queryDataLength = null
       }else{
        QueryStayBox(data).then(res => {
            console.log(res);
            this.responseDataArray = res.data
            this.queryDataLength = this.responseDataArray.length
            console.log( 'this.responseDataArray',this.responseDataArray);
            this.finished = true
            this.loading=false
        })
       }
      },
      // 查看详情
      showDetail(val){
        console.log('val',val);
        this.showDataDetail = true
        val.handleTime = formatTime(val.handleTime)
        this.showList = val
      },
      // 关闭详情页面
      cancelForm(){
        this.searchValue = ''
        this.onSearch()
        this.showDataDetail = false
      },
  
    }
  
  }
  </script>
  
  <style lang="scss" >
  .overdue{
    .searchContent{
      .van-cell__title{
        line-height: 45px;
      }
    }
  
    .van-nav-bar__left{
      left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .van-search__action{
      color: #0283ef;
      font-size: 18px;
    }
  
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .overdueBlock{
      width: 95%;
      // height: 43%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
      .van-field__control{
        width: 90%;
      }
    }
    }
   
  
  }
  
  </style>